export const EDITOR_MAX_LENGTH = 5000;

export const WYSIWYG_OPTIONS = {
  enter: "p" as "p",
  addNewLine: false,
  countTextSpace: true,
  showCharsCounter: true,
  showWordsCounter: true,
  showBrowserColorPicker: false,
  limitChars: EDITOR_MAX_LENGTH,
  disablePlugins:'preview, video, media, file, xpath, tooltip, symbols, sticky, resize-handler,about,focus,class-span,wrap-text-nodes,clipboard,paste,paste-storage,fullsize,iframe,inline-popup,link,mobile,ordered-list,search,print',
  buttons:
    'source,bold,italic,underline,strikethrough,eraser,ul,ol,indent,outdent,left,center,right,font,fontsize,paragraph,brush,image,copyformat',
};
